class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.line = this.dataset.index;
    this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.showConfirmation();
    });
  }

  showConfirmation() {
    const modal        = document.getElementById('cart-remove-confirmation-modal');
    const confirmBtn   = modal.querySelector('#cart-remove-modal-confirm');
    const favRemoveBtn = modal.querySelector('#cart-remove-modal-fav-remove');
    const cancelBtn    = modal.querySelector('#cart-remove-modal-cancel');
    const closeBtn     = modal.querySelector('#cart-remove-modal-close');
    const modalContent = modal.querySelector('div');

    modal.classList.remove('hidden');

    const onConfirm = () => {
      this.cartItems.updateQuantity(this.line, 0);
      cleanup();
    };

    const onFavRemove = () => {
      const favTrigger = document.getElementById(`cart-fav-trigger-${this.line}`);
      if (favTrigger) {
        favTrigger.click();
      }
      this.cartItems.updateQuantity(this.line, 0);
      cleanup();
    };

    const onCancel = () => cleanup();
    const onClose = () => cleanup();

    const onOutsideClick = (event) => {
      if (!modalContent.contains(event.target)) {
        cleanup();
      }
    };

    function cleanup() {
      modal.classList.add('hidden');
      confirmBtn.removeEventListener('click', onConfirm);
      favRemoveBtn.removeEventListener('click', onFavRemove);
      cancelBtn?.removeEventListener('click', onCancel);
      closeBtn?.removeEventListener('click', onClose);
      document.removeEventListener('click', onOutsideClick, true);
    }

    confirmBtn.addEventListener('click', onConfirm);
    favRemoveBtn.addEventListener('click', onFavRemove);
    cancelBtn?.addEventListener('click', onCancel);
    closeBtn?.addEventListener('click', onClose);
    document.addEventListener('click', onOutsideClick, true);
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.container =
    document.getElementById('Cart') ||
    document.getElementById('main-cart-footer');
    this.observer = null;
    this.pageContainer = this;
    
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    window.addEventListener('hollyWishListAppRemoveFromCart', async () => {
      await checkAndUpdateCartDiscount();
      this.refresh();
    });

    // Listen for cart clear event
    document.addEventListener('cart:clear', (event) => {
      this.clearCart();
    });

    // Cart updated events - sepete ürün eklendiğinde sticky bar'ı kontrol et
    document.addEventListener('cart:updated', () => {
      this.handleCartUpdate();
    });
    
    // Line item change events
    document.addEventListener('line-item:change:end', (event) => {
      this.handleCartUpdate();
    });

    // Window resize event to handle screen size changes
    window.addEventListener('resize', debounce(() => {
      this.handleCartUpdate();
    }, 250));

    // Listen for hp-cart-sync cart updated event
    window.addEventListener('hp-cart-sync:cart-updated', () => {
      this.refreshCartContent();
    });

    this.setupCouponEventListeners()
    this.addEventListener('change', debouncedOnChange.bind(this));
    this.initializeStickyBar();
    this.setupGiftEventListeners();
  }
  
  initializeStickyBar() {
    // Page load'da sepet durumunu kontrol et
    setTimeout(() => {
      this.handleCartUpdate();
    }, 100); // DOM'un tamamen yüklenmesini bekle
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    const isGiftCheckbox = event.srcElement.dataset.giftEventSetup === 'true';
    if (!isGiftCheckbox) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  onCartUpdate() {
    fetch(window.hpI18n.url('/cart?section_id=main-cart-items'))
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  async updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    
    try {
      const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } });
      const state = await response.text();
      const parsedState = JSON.parse(state);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }
      
      // Check and update cart discount before UI update
      const updatedSections = await checkAndUpdateCartDiscount(
        this.getSectionsToRender().map(s => s.section).join(',')
      );
      
      if (updatedSections) {
        parsedState.sections = updatedSections;
      }
      
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section => {
        const elementToReplace = 
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = 
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

        // Re-setup gift event listeners after DOM update
        this.setupGiftEventListeners();

      const cartItemCountContainer = document.getElementById('cart-item-count-container');
      if (cartItemCountContainer) {
        if (parsedState.item_count > 0) {
          cartItemCountContainer.innerHTML = `<p class="hp:text-md hp:text-gray-500 hp:!pb-1">(${window.cartStrings.item_count.replace('[count]', parsedState.item_count)})</p>`;
        } else {
          cartItemCountContainer.innerHTML = '';
        }
      }

      const clearCartButtonContainer = document.getElementById('clear-cart-button-container');
      if (clearCartButtonContainer) {
        if (parsedState.item_count > 0) {
          clearCartButtonContainer.style.display = 'block';
        } else {
          clearCartButtonContainer.style.display = 'none';
        }
      }

      const cartHeading = document.getElementById('cart-heading');
      if (cartHeading) {
        if (parsedState.item_count > 0) {
          cartHeading.classList.remove('hp:hidden');
        } else {
          cartHeading.classList.add('hp:hidden');
        }
      }
      
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
      }
      
      // Update sticky bar after quantity change
      this.updateStickyTotal();
      this.setupStickyCheckoutBar();
      
      // Trigger sticky bar update event
      if (parsedState.item_count === 0) {
        const stickyBar = document.getElementById('sticky-checkout-bar');
        if (stickyBar) {
          stickyBar.style.transform = 'translateY(100%)';
          stickyBar.style.display = 'none';
        }
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }
      
      // Dispatch events for sticky bar handling
      document.dispatchEvent(new CustomEvent('line-item:change:end', {
        detail: { quantity: quantity, cart: parsedState }
      }));
      
      publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
    } catch (error) {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line);
    }
  }

  updateLiveRegions(line, message) {
    const translatedMessage = (typeof window !== 'undefined' && window.translateShopifyCartMessage)
      ? window.translateShopifyCartMessage(message)
      : message;
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = translatedMessage;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');
    const checkoutButton = document.getElementById('checkout');
    if (checkoutButton) {
      checkoutButton.disabled = true;
    }

    if (line) {
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
    const checkoutButton = document.getElementById('checkout');
    if (checkoutButton) {
      checkoutButton.disabled = false;
    }

    if (line) {
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
  }

  clearCart() {
    this.enableLoading();
    fetch(`${routes.cart_clear_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then((response) => {
      return response.text();
    })
    .then(() => {
      this.refresh();
      
      // Sepet temizlendiğinde sticky bar'ı gizle
      const stickyBar = document.getElementById('sticky-checkout-bar');
      if (stickyBar) {
        stickyBar.style.transform = 'translateY(100%)';
        stickyBar.style.display = 'none';
      }
      
      // Observer'ı temizle
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    })
    .catch((error) => {
      console.error('Error clearing cart:', error);
      this.disableLoading();
    });
  }

  refresh() {
    this.enableLoading();
    
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        // Update cart state
        this.classList.toggle('is-empty', cart.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', cart.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', cart.item_count === 0);

        // Fetch updated sections
        const sections = this.getSectionsToRender();
        const sectionPromises = sections.map(section => 
          fetch(`${window.location.pathname}?section_id=${section.section}`)
            .then(response => response.text())
            .then(html => ({ ...section, html }))
        );

        return Promise.all(sectionPromises);
      })
      .then((sectionsData) => {
        // Update each section
        sectionsData.forEach(sectionData => {
          const elementToReplace = 
            document.getElementById(sectionData.id).querySelector(sectionData.selector) || 
            document.getElementById(sectionData.id);
          elementToReplace.innerHTML = 
            this.getSectionInnerHTML(sectionData.html, sectionData.selector);
        });

        // Re-setup coupon event listeners after DOM update
        this.setupCouponEventListeners();
        
        // Re-setup gift event listeners after DOM update
        this.setupGiftEventListeners();

        // Update cart info elements
        return fetch(`${routes.cart_url}.js`);
      })
      .then((response) => response.json())
      .then((cart) => {
        const cartItemCountContainer = document.getElementById('cart-item-count-container');
        if (cartItemCountContainer) {
          if (cart.item_count > 0) {
            cartItemCountContainer.innerHTML = `<p class="hp:text-md hp:text-gray-500 hp:!pb-1">(${window.cartStrings.item_count.replace('[count]', cart.item_count)})</p>`;
          } else {
            cartItemCountContainer.innerHTML = '';
          }
        }

        const clearCartButtonContainer = document.getElementById('clear-cart-button-container');
        if (clearCartButtonContainer) {
          if (cart.item_count > 0) {
            clearCartButtonContainer.style.display = 'block';
          } else {
            clearCartButtonContainer.style.display = 'none';
          }
        }

        const cartHeading = document.getElementById('cart-heading');
        if (cartHeading) {
          if (cart.item_count > 0) {
            cartHeading.classList.remove('hp:hidden');
          } else {
            cartHeading.classList.add('hp:hidden');
          }
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
        
        // Update sticky bar after cart refresh
        this.updateStickyTotal();
        this.setupStickyCheckoutBar();
      })
      .catch((e) => {
        console.error(e);
        this.disableLoading();
      })
      .finally(() => {
        this.disableLoading();
      });
  }
  
  setupStickyCheckoutBar() {
    const stickyBar = document.getElementById('sticky-checkout-bar');
    const checkoutButton = document.getElementById('checkout');
    
    // Check if we're on mobile device
    const isMobile = window.innerWidth < 768;
    
    // Only show sticky bar on mobile devices
    if (!isMobile) {
      if (stickyBar) {
        stickyBar.style.transform = 'translateY(100%)';
        stickyBar.style.display = 'none';
      }
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      return;
    }
    
    // Sepet boşsa sticky bar'ı gizle
    if (!checkoutButton || !stickyBar) {
      if (stickyBar) {
        stickyBar.style.transform = 'translateY(100%)';
        stickyBar.style.display = 'none';
      }
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      return;
    }
    
    // Sticky bar'ı göster (sadece mobile'da)
    stickyBar.style.display = 'block';
    
    if (this.observer) {
      this.observer.disconnect();
    }
    
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Checkout button görünüyorsa sticky bar'ı gizle
          stickyBar.style.transform = 'translateY(100%)';
        } else {
          // Checkout button görünmüyorsa sticky bar'ı göster
          stickyBar.style.transform = 'translateY(0)';
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });
    
    this.observer.observe(checkoutButton);
  }
  
  updateStickyTotal() {
    const stickyTotal = document.querySelector('[data-sticky-total]');
    const mainTotal = document.querySelector('[data-last-amount]');

    if (stickyTotal && mainTotal) {
      stickyTotal.innerHTML = mainTotal.innerHTML;
    }
  }
  
  handleCartUpdate() {
    // Sepet durumunu kontrol et
    const checkoutButton = document.getElementById('checkout');
    const stickyBar = document.getElementById('sticky-checkout-bar');
    const isMobile = window.innerWidth < 768;
    
    if (!stickyBar) return;
    
    // Desktop'ta sticky bar'ı her zaman gizle
    if (!isMobile) {
      stickyBar.style.transform = 'translateY(100%)';
      stickyBar.style.display = 'none';
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      return;
    }
    
    if (checkoutButton) {
      // Sepet dolu - sticky bar'ı aktif et (sadece mobile'da)
      this.setupStickyCheckoutBar();
      this.updateStickyTotal();
    } else {
      // Sepet boş - sticky bar'ı gizle
      stickyBar.style.transform = 'translateY(100%)';
      stickyBar.style.display = 'none';
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  refreshCartContent() {
    // Cart'ı refresh et ama loading state'i gösterme
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        // Update cart state
        this.classList.toggle('is-empty', cart.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', cart.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', cart.item_count === 0);

        // Fetch updated sections
        const sections = this.getSectionsToRender();
        const sectionPromises = sections.map(section => 
          fetch(`${window.location.pathname}?section_id=${section.section}`)
            .then(response => response.text())
            .then(html => ({ ...section, html }))
        );

        return Promise.all(sectionPromises);
      })
      .then((sectionsData) => {
        // Update each section
        sectionsData.forEach(sectionData => {
          const elementToReplace = 
            document.getElementById(sectionData.id).querySelector(sectionData.selector) || 
            document.getElementById(sectionData.id);
          elementToReplace.innerHTML = 
            this.getSectionInnerHTML(sectionData.html, sectionData.selector);
        });

        // Re-setup coupon event listeners after DOM update
        this.setupCouponEventListeners();

        // Update cart info elements
        return fetch(`${routes.cart_url}.js`);
      })
      .then((response) => response.json())
      .then((cart) => {
        const cartItemCountContainer = document.getElementById('cart-item-count-container');
        if (cartItemCountContainer) {
          if (cart.item_count > 0) {
            cartItemCountContainer.innerHTML = `<p class="hp:text-md hp:text-gray-500 hp:!pb-1">(${window.cartStrings.item_count.replace('[count]', cart.item_count)})</p>`;
          } else {
            cartItemCountContainer.innerHTML = '';
          }
        }

        const clearCartButtonContainer = document.getElementById('clear-cart-button-container');
        if (clearCartButtonContainer) {
          if (cart.item_count > 0) {
            clearCartButtonContainer.style.display = 'block';
          } else {
            clearCartButtonContainer.style.display = 'none';
          }
        }

        const cartHeading = document.getElementById('cart-heading');
        if (cartHeading) {
          if (cart.item_count > 0) {
            cartHeading.classList.remove('hp:hidden');
          } else {
            cartHeading.classList.add('hp:hidden');
          }
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
        
        // Update sticky bar after cart refresh
        this.updateStickyTotal();
        this.setupStickyCheckoutBar();
      })
      .catch((e) => {
        console.error('Error refreshing cart content:', e);
      });
  }



    // Holly Coupon

  async handleCoupon(isDeleteRequest = false, value) {
    // Silmə əməliyyatı deyilsə və artıq bir kod varsa, yeni kod əlavə etməyə icazə vermə
    if (!isDeleteRequest && this.appliedCoupons.length >= 1) {
      this.showCouponError(window.hpI18n.t('theme_i18n.cart.one_coupon'))
      return
    }

    const discountCodes = isDeleteRequest
      ? this.appliedCoupons.filter(code => code !== value)
      : !this.appliedCoupons.includes(value) ? [...this.appliedCoupons, value] : this.appliedCoupons

    this.sendCouponRequest(discountCodes, value)
  }

  async sendCouponRequest(codeArray, newCode){
    const isDeleteRequest = !codeArray.includes(newCode)

    this.container.classList.add('cart-disabled');

    let currentButton = null
    if(isDeleteRequest){
      currentButton = document.querySelector(`[data-remove-coupon-button][value="${newCode}"]`)
    } else {
      currentButton = document.querySelector('[data-apply-coupon-button]')
    }
    if (currentButton) {
      currentButton.lastElementChild?.classList.add('hp-loading')
      currentButton.disabled = true
    }
    try {
      const cart = await this.updateDiscountCodes(codeArray)
      const appliedCode = cart.discount_codes?.find(code => code.code?.toLowerCase() === newCode?.toLowerCase());

      if (isDeleteRequest || appliedCode?.applicable) {
        // Update the applied coupons array
        this.appliedCoupons = codeArray
        
        // Clear input field after successful coupon application
        if (!isDeleteRequest) {
          const couponInput = this.container.querySelector('[data-coupon-form] input[type="text"]');
          if (couponInput) {
            couponInput.value = '';
          }
        }
        
        // Update the discount codes display immediately
        this.updateDiscountCodesDisplay(codeArray);
        
        // Check and update cart discount before refreshing
        await checkAndUpdateCartDiscount();
        
        // Then refresh the cart to update totals and other sections
        this.refresh()
      } else {
        // Shopify uygulanamayan kodu sepette bırakır; önceki kodlara geri al
        await this.updateDiscountCodes(this.appliedCoupons)
        this.showCouponError(window.hpI18n.t('theme_i18n.cart.invalid_coupon'))
      }
    } catch (error) {
      console.warn(error);
      this.showCouponError(window.hpI18n.t('theme_i18n.cart.invalid_coupon'))
    } finally {
      this.container.classList.remove('cart-disabled');
      if (currentButton) {
        currentButton.lastElementChild?.classList.remove('hp-loading')
        currentButton.disabled = false
      }
    }
  }
     setupCouponEventListeners(){
       if (!this.container) return;
     const appliedCouponsList = this.container.querySelector('[data-coupon-list]')?.getAttribute('data-coupon-list');
     this.appliedCoupons = appliedCouponsList?.split(',').filter(code => code.trim()) || []
 
     const couponContainer = this.container.querySelector('[data-coupon-container]')
     if (!couponContainer) return;
     
     const couponForm = couponContainer.querySelector('[data-coupon-form]');
     if (!couponForm) return;
     const couponApplyButton = couponForm.querySelector('[data-apply-coupon-button]')
     const couponInput = couponForm.querySelector('input[type="text"]')
     const removeCouponButtons = couponContainer.querySelectorAll('[data-remove-coupon-button]')
     
     // Remove existing event listeners to prevent duplicates
     if (this.couponApplyHandler) {
       couponApplyButton.removeEventListener('click', this.couponApplyHandler);
     }
     if (this.couponInputHandler) {
       couponInput.removeEventListener('keydown', this.couponInputHandler);
     }
     
     // Create new event handlers
     this.couponApplyHandler = () => {
       if(couponInput.value.length > 0){
         this.handleCoupon(false, couponInput.value)
       }
     };
     
     this.couponInputHandler = (e) => {
       if(e.code === 'Enter') e.preventDefault()
     };
     
     // Add event listeners
     couponApplyButton.addEventListener('click', this.couponApplyHandler);
     couponInput.addEventListener('keydown', this.couponInputHandler);

     // Use delegated listener on the container so we can re-setup safely
     // without leaking duplicate listeners on each remove button
     if (this.couponRemoveDelegateHandler) {
       couponContainer.removeEventListener('click', this.couponRemoveDelegateHandler);
     }
     this.couponRemoveDelegateHandler = (event) => {
       const button = event.target.closest('[data-remove-coupon-button]');
       if (!button || !couponContainer.contains(button)) return;
       if (button.disabled) return;
       this.handleCoupon(true, button.value);
     };
     couponContainer.addEventListener('click', this.couponRemoveDelegateHandler);
   }
     updateDiscountCodesDisplay(codeArray) {
     const couponContainer = this.container.querySelector('[data-coupon-container]');
     if (!couponContainer) return;
     
     // Find or create the coupon list container
     let couponListContainer = couponContainer.querySelector('[data-coupon-list]');
     
     if (codeArray.length > 0) {
       if (!couponListContainer) {
         // Create the coupon list container if it doesn't exist
         const couponForm = couponContainer.querySelector('[data-coupon-form]');
         couponListContainer = document.createElement('div');
         couponListContainer.className = 'hp:mb-4';
         couponListContainer.setAttribute('data-coupon-list', codeArray.join(','));
         couponForm.parentNode.insertBefore(couponListContainer, couponForm);
       } else {
         // Update the data attribute
         couponListContainer.setAttribute('data-coupon-list', codeArray.join(','));
       }
       
              // Generate the HTML for applied coupons
       const couponHtml = codeArray.map(code => `
         <div class="hp:flex hp:items-center hp:justify-between hp:gap-2 hp:bg-green-100 hp:p-4 hp:mb-2 hp:!text-uppercase">
           <div class="hp:flex hp:items-center hp:gap-2">
             <div class="" id="">
               <svg class=" hp:size-6 hp:text-neutral-500" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                 <path d="M0 11L9 20L20 9V0H11L0 11ZM19 1V8.586L9 18.586L1.414 11L11.414 1H19Z" fill="currentColor"></path>
                 <path d="M14 7C14.5523 7 15 6.55228 15 6C15 5.44772 14.5523 5 14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7Z" fill="currentColor"></path>
               </svg>
             </div>
             <span class="hp:text-sm hp:text-neutral-500  hp:text-[14px] hp:ml-3">${code}</span>
           </div>
           <button class="hp:has-[.hp-loading]:!text-transparent hp:relative hp:cursor-pointer" type="button" data-remove-coupon-button value="${code}">
             <span><div class="" id="">
               <svg class=" hp:size-4" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                 <path d="M0.999 13.5303L6.999 7.53026L12.999 13.5303L13.5293 13L7.52925 7.00001L13.5293 1.00001L12.999 0.469757L6.999 6.46976L0.999 0.469757L0.46875 1.00001L6.46875 7.00001L0.46875 13L0.999 13.5303Z" fill="currentColor"></path>
               </svg>
             </div></span>
             <small class="hp:!text-black hp:!right-2 hp:!size-4"></small>
           </button>
         </div>
       `).join('');
       
       couponListContainer.innerHTML = couponHtml;
     } else {
       // Remove the coupon list container if no coupons are applied
       if (couponListContainer) {
         couponListContainer.remove();
       }
     }
     
     // Re-setup event listeners for the new remove buttons
     this.setupCouponEventListeners();
   }

   showCouponError(errorMessage = window.hpI18n.t('theme_i18n.cart.invalid_coupon')) {
     const couponError = this.container.querySelector('[data-coupon-error]')
     if (couponError) {
       couponError.textContent = errorMessage
       couponError.classList.remove('hp:opacity-0')
       couponError.scrollIntoView({ behavior: 'smooth', block: 'center' })
       setTimeout(() => {
         couponError.classList.add('hp:opacity-0')
       }, 3500)
     }
   }
  async updateDiscountCodes(codes) {
    // Ajax Cart API: virgülle ayrılmış liste sepetteki tüm kodların yerine geçer, boş string hepsini kaldırır
    const response = await fetch(`${routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: codes.join(',') })
    })
    if (!response.ok) throw new Error(`cart/update.js failed: ${response.status}`)
    return response.json()
  }

  // Holly Gift Package System
  setupGiftEventListeners() {
    // Sayfa yüklendiğinde tüm modal'ları kapat
    const allModals = this.pageContainer.querySelectorAll('[id*="gift-checkbox-modal"]');
    allModals.forEach(modal => {
      modal.classList.add('hp:hidden');
    });

    // Hediye checkbox'ları için event listener'lar
    const giftCheckboxes = this.pageContainer.querySelectorAll('[data-gift-checkbox-input]');
    const giftModalButtons = this.pageContainer.querySelectorAll('[data-gift-checkbox-modal-open]');
    giftCheckboxes.forEach(checkbox => {
      if (!checkbox.hasAttribute('data-gift-event-setup')) {
        checkbox.setAttribute('data-gift-event-setup', 'true');
        checkbox.addEventListener('change', (e) => {
          this.handleGiftCheckboxChange(e.target);
        });
      }
    });

    giftModalButtons.forEach(button => {
      if (!button.hasAttribute('data-gift-modal-event-setup')) {
        button.setAttribute('data-gift-modal-event-setup', 'true');
        button.addEventListener('click', (e) => {
          this.openGiftModal(e.target.getAttribute('data-gift-checkbox-modal-open'));
        });
      }
    });

    // Save button'lar için event listener'lar
    const saveButtons = this.pageContainer.querySelectorAll('[data-save-gift-modal]');
    saveButtons.forEach(button => {
      if (!button.hasAttribute('data-save-event-setup')) {
        button.setAttribute('data-save-event-setup', 'true');
        button.addEventListener('click', (e) => {
          this.saveGiftModal(e.currentTarget.getAttribute('data-item-id'));
        });
      }
    });
  }

  async handleGiftCheckboxChange(checkbox) {
    // Reset işlemi sırasında event'i yok say
    if (checkbox.hasAttribute('data-resetting')) {
      return;
    }
    
    const itemKey = checkbox.getAttribute('data-line-key');
    const quantity = checkbox.getAttribute('data-quantity');
    const isChecked = checkbox.checked;

    if (isChecked) {
      // Checkbox'ın original durumunu sakla (modal açılmadan önceki durum)
      const originalState = !isChecked; // Şu anda true ise, önceki durumu false'tu
      checkbox.setAttribute('data-original-state', originalState.toString());
      
      // Hediye paketi açıldığında modal'ı aç
      const modalId = checkbox.getAttribute('id').replace('gift-checkbox-', 'gift-checkbox-modal-');
      const itemIdForModal = modalId.replace('gift-checkbox-modal-', '');
      await this.openGiftModal(itemIdForModal);
    } else {
      // Hediye paketi kapatıldığında property'yi kaldır
      await this.updateGiftProperties(itemKey, quantity, false, '');
    }
  }

  async openGiftModal(itemId) {
    const modal = document.getElementById(`gift-checkbox-modal-${itemId}`);
    
    if (modal) {
      // Modal'daki değerleri properties'lerden güncelle
      await this.populateGiftModalValues(modal, itemId);
      
      // Modal'ı göster
      modal.classList.remove('hp:hidden');
      modal.style.display = 'flex'; // Force display
      
      // Event listener'ları setup et
      this.setupGiftModalEvents(modal, itemId);
      
      // Body scroll'unu engelle
      document.body.style.overflow = 'hidden';
    } else {
      console.error('Modal not found for itemId:', itemId);
    }
  }

  async populateGiftModalValues(modal, itemId) {
    const checkbox = document.getElementById(`gift-checkbox-${itemId}`);
    const isCurrentlyGift = checkbox ? checkbox.checked : false;
    
    // Item properties'lerden hediye notu bilgisini al
    const existingNote = await this.getGiftNoteFromProperties(itemId);
    const hasExistingNote = existingNote && existingNote.length > 0;
    
    // Modal elementlerini bul
    const packageCheckbox = modal.querySelector('[data-modal-gift-package]');
    const noteCheckbox = modal.querySelector('[data-modal-gift-note]');
    const noteLabel = modal.querySelector('[data-gift-note-label]');
    const textarea = modal.querySelector('[data-gift-note-textarea]');
    const characterCount = modal.querySelector('[data-character-count]');
    
    // Değerleri set et
    if (packageCheckbox) packageCheckbox.checked = isCurrentlyGift;
    if (noteCheckbox) {
      noteCheckbox.checked = hasExistingNote;
      // Hediye paketi seçili değilse hediye notu checkbox'ı disabled olsun
      noteCheckbox.disabled = !isCurrentlyGift;
    }
    if (noteLabel) {
      // Label görünümünü güncelle
      if (!isCurrentlyGift) {
        noteLabel.classList.add('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      } else {
        noteLabel.classList.remove('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      }
    }
    if (textarea) {
      textarea.value = existingNote || '';
      textarea.disabled = !hasExistingNote || !isCurrentlyGift;
    }
    if (characterCount) {
      this.updateCharacterCount(textarea, characterCount);
    }
  }

  setupGiftModalEvents(modal, itemId) {
    // Önceki event'leri temizle
    if (modal.hasAttribute('data-modal-events-setup')) {
      return;
    }
    modal.setAttribute('data-modal-events-setup', 'true');

    const packageCheckbox = modal.querySelector('[data-modal-gift-package]');
    const noteCheckbox = modal.querySelector('[data-modal-gift-note]');
    const noteLabel = modal.querySelector('[data-gift-note-label]');
    const textarea = modal.querySelector('[data-gift-note-textarea]');
    const characterCount = modal.querySelector('[data-character-count]');
    const saveButton = modal.querySelector('[data-save-gift-modal]');

    // Ana checkbox'ın orijinal durumunu al
    const mainCheckbox = document.getElementById(`gift-checkbox-${itemId}`);
    
    // Original state'i data-original-state attribute'inden al
    let originalMainCheckboxState = false;
    if (mainCheckbox && mainCheckbox.hasAttribute('data-original-state')) {
      originalMainCheckboxState = mainCheckbox.getAttribute('data-original-state') === 'true';
    } else {
      originalMainCheckboxState = mainCheckbox ? mainCheckbox.checked : false;
    }

    // Modal açıldığında orijinal değerleri sakla
    const originalValues = {
      packageChecked: packageCheckbox.checked,
      noteChecked: noteCheckbox.checked,
      noteText: textarea.value,
      noteDisabled: noteCheckbox.disabled,
      mainCheckboxChecked: originalMainCheckboxState
    };

    // Package checkbox değiştiğinde
    packageCheckbox.addEventListener('change', () => {
      if (!packageCheckbox.checked) {
        noteCheckbox.checked = false;
        noteCheckbox.disabled = true;
        noteLabel.classList.add('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
        textarea.disabled = true;
        textarea.value = '';
        this.updateCharacterCount(textarea, characterCount);
      } else {
        noteCheckbox.disabled = false;
        noteLabel.classList.remove('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      }
    });

    // Note checkbox değiştiğinde
    noteCheckbox.addEventListener('change', () => {
      if (noteCheckbox.checked && packageCheckbox.checked) {
        textarea.disabled = false;
        textarea.focus();
      } else {
        textarea.disabled = true;
        if (!packageCheckbox.checked) {
          textarea.value = '';
          this.updateCharacterCount(textarea, characterCount);
        }
      }
    });

    // Textarea karakter sayımı
    textarea.addEventListener('input', () => {
      this.updateCharacterCount(textarea, characterCount);
    });

    // Modal reset fonksiyonu
    const resetModalValues = () => {
      // Ana checkbox'ı orijinal durumuna döndür (event tetiklememek için geçici olarak event'i kaldır)
      if (mainCheckbox) {
        // Event'leri geçici olarak engelle
        mainCheckbox.setAttribute('data-resetting', 'true');
        
        // Checkbox'ı reset et
        mainCheckbox.checked = originalValues.mainCheckboxChecked;
        
        // Event engellemesini kaldır ve original state attribute'ini temizle
        setTimeout(() => {
          mainCheckbox.removeAttribute('data-resetting');
          mainCheckbox.removeAttribute('data-original-state');
        }, 10);
      }
      
      packageCheckbox.checked = originalValues.packageChecked;
      noteCheckbox.checked = originalValues.noteChecked;
      noteCheckbox.disabled = originalValues.noteDisabled;
      
      // Label görünümünü restore et
      if (originalValues.noteDisabled) {
        noteLabel.classList.add('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      } else {
        noteLabel.classList.remove('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      }
      
      textarea.value = originalValues.noteText;
      textarea.disabled = !originalValues.noteChecked || !originalValues.packageChecked;
      this.updateCharacterCount(textarea, characterCount);
    };

    // Modal close event'i için
    const handleModalClose = () => {
      resetModalValues();
      modal.classList.add('hp:hidden');
      modal.style.display = 'none'; // Force hide
      // Body scroll'unu geri aç
      document.body.style.overflow = 'auto';
    };

    // Modal dışına tıklayınca kapat ve reset et
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        handleModalClose();
      }
    });

    // X butonu click event'i
    const closeButton = modal.querySelector('[data-modal-close]');
    if (closeButton) {
      closeButton.addEventListener('click', handleModalClose);
    }

    // Modal'ın mevcut close event'lerini override et
    modal.setAttribute('data-modal-close-handler', 'true');
    modal.handleModalClose = handleModalClose;
  }

  updateCharacterCount(textarea, countElement) {
    const remaining = 144 - textarea.value.length;
    countElement.textContent = window.hpI18n.t('theme_i18n.cart.characters_remaining', { count: remaining });
    countElement.className = remaining < 20 ? 'hp:!text-[12px] hp:text-red-500' : 'hp:!text-[12px] hp:text-gray-500';
  }

  async saveGiftModal(itemId) {
    const modal = document.getElementById(`gift-checkbox-modal-${itemId}`);
    const packageCheckbox = modal.querySelector('[data-modal-gift-package]');
    const noteCheckbox = modal.querySelector('[data-modal-gift-note]');
    const textarea = modal.querySelector('[data-gift-note-textarea]');
    const button = modal.querySelector('[data-save-gift-modal]');
    const buttonText = button.querySelector('[data-button-text]');
    const buttonLoading = button.querySelector('[data-button-loading]');
    
    const isGiftPackage = packageCheckbox.checked;
    const giftNote = noteCheckbox.checked ? textarea.value : '';
    
    // Loading state'ini başlat
    button.disabled = true;
    buttonText.classList.add('hp:opacity-0');
    buttonLoading.classList.remove('hp:opacity-0');
    buttonLoading.classList.add('hp:opacity-100');
    
    try {
      // Ana checkbox'ı güncelle
      const mainCheckbox = document.getElementById(`gift-checkbox-${itemId}`);
      if (mainCheckbox) {
        mainCheckbox.checked = isGiftPackage;
        
        // Original state attribute'ini temizle (değişiklikler kaydedildi)
        mainCheckbox.removeAttribute('data-original-state');
        
        // Line index ve key bilgilerini al
        const itemKey = mainCheckbox.getAttribute('data-line-key');
        const quantity = mainCheckbox.getAttribute('data-quantity');
        
        // Cart properties'i güncelle
        await this.updateGiftProperties(itemKey, quantity, isGiftPackage, giftNote);
      }
      
      // Modal'ı kapat
      modal.classList.add('hp:hidden');
      // Body scroll'unu geri aç
      document.body.style.overflow = 'auto';
    } catch (error) {
      console.error('Error saving gift modal:', error);
    } finally {
      // Loading state'ini bitir
      button.disabled = false;
      buttonText.classList.remove('hp:opacity-0');
      buttonLoading.classList.add('hp:opacity-0');
      buttonLoading.classList.remove('hp:opacity-100');
    }
  }

  async getGiftNoteFromProperties(itemId) {
    try {
      const response = await fetch(window.hpI18n.url('/cart.js'));
      const cart = await response.json();
      
      // Item ID'si "product-id-item-key" formatında, bunu parse et
      const parts = itemId.split('-');
      const itemKey = parts[parts.length - 1]; // Son part line index
      
      // Cart items'dan ilgili item'ı bul (line index 1-based)
      const item = cart.items[itemKey - 1];
      
      if (item && item.properties && item.properties['_line_item_gift_note']) {
        return item.properties['_line_item_gift_note'];
      }
      
      return '';
    } catch (error) {
      console.error('Error getting gift note from properties:', error);
      return '';
    }
  }

  async updateGiftProperties(itemKey, quantity, isGift, giftNote = '') {
    this.pageContainer.classList.add('cart-disabled');
    
    let properties = {};
    
    if (isGift) {
      properties['_is_line_item_gift'] = 'true';
      if (giftNote) {
        properties['_line_item_gift_note'] = giftNote;
      }
    } else {
      properties = {_: null};
    }

    const body = JSON.stringify({
      id: itemKey,
      quantity: Number(quantity),
      properties: properties
    });

    try {
      const response = await fetch(window.hpI18n.url('/cart/change.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body
      });

      if (response.ok) {
        this.refresh();
      } else {
        throw new Error('Gift properties update failed');
      }
    } catch (error) {
      console.error('Error updating gift properties:', error);
    } finally {
      this.pageContainer.classList.remove('cart-disabled');
    }
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}


if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
